<template>
    <div
        :class="['gl-text', isFocused && 'focus', disabled && 'disabled', isRequired &&
            'required', isFilled && 'fill']"
        @click="onClick"
    >
        <template v-if='placeholder'>
            <span class="placeholder">{{placeholder}}</span>
            <hr>
        </template>
        <input
            :disabled="disabled"
            v-if="!password"
            type="text"
            :name="name"
            v-model="internalValue"
            :maxlength="limit"
            @focus="onFocusIn"
            @focusout="onFocusOut"
            ref="input"
        >
        <input
            :disabled="disabled"
            v-else type="password"
            :name="name"
            v-model="internalValue"
            :maxLength="limit"
            @focus='onFocusIn'
            @focusout="onFocusOut"
            ref="input"
        >
        <aside
            :class="['alert', showRequired && 'show']"
            v-if="isRequired"
        >
            {{required}}
        </aside>
        <aside
            :class="['counter', isFocused && 'show', internalValue.length >= limit && 'max']"
            v-if='isLimit'
        >
            {{internalValue.length}}/{{limit}}
        </aside>
    </div>
</template>

<script>
    import { isEmpty } from 'ramda';

    export default {
        name: 'gl-text',
        props: {
            name: {
                type: String,
                default: 'input'
            },
            value: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String
            },
            required: {
                type: String,
                default: ''
            },
            password: {
                type: Boolean,
                default: false
            },
            limit: {
                type: Number,
                default: -1
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                init: true,
                isFocused: false,
                isLimit: (this.limit > 0),
                internalValue: this.value,
                input: ''
            };
        },
        methods: {
            onClick() {
                if (!this.disabled) {
                    const input = this.$refs.input;
                    this.init = false;
                    input.focus();
                }
            },
            onFocusIn() {
                this.isFocused = true;
            },
            onFocusOut() {
                this.isFocused = false;
            },
            onLimit() {
                return !(this.internalValue.length > this.limit);
            }

        },
        computed: {
            isFilled() {
                return !isEmpty(this.internalValue);
            },
            showRequired() {
                return (isEmpty(this.internalValue) && !this.isFocused && !this.init);
            },
            isRequired() {
                return !isEmpty(this.required);
            }
        },
        watch: {
            internalValue() {
                this.$emit('input', this.internalValue);
            }
        },
        created() {
            this.internalValue = this.value;
            this.init = true;
        }
    };
</script>




// WEBPACK FOOTER //
// src/groovielize/components/TextInput.vue